import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="pt-20">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-24 text-center">
          <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 mx-auto mb-6">
            <i className="ri-emotion-sad-line text-3xl"></i>
          </div>
          <h2 className="font-heading text-3xl font-bold text-foreground-900 mb-3">404</h2>
          <p className="text-foreground-600 mb-8">哎呀，这个页面好像被罚站了，怎么也找不到～</p>
          <Link
            to="/"
            className="px-6 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors inline-block whitespace-nowrap cursor-pointer"
          >
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}